module.exports = {
  appId: '91d0ocmhc5kc',
  appPath: "merchant-solutions", // all lowercase and space should be replaced with "-"
  version: '1.0.4',
  // indexRoute: '/home',
  base: "tzmp", // dot not change this
}
